const tarefaStore = {
    state() {
        return {
            tarefas: '',
            categoria: '',
            codigo_de_barras: '',
            validade: '',
        };
    },
    mutations: {
        setTarefas(state, payload) {
            state.tarefas = payload;
        },
        setCategoria(state, payload) {
            state.categoria = payload;
        },
        setCodigo(state, payload) {
            state.codigo_de_barras = payload;
        },
        setValidade(state, payload) {
            state.validade = payload;
        },
    },
    actions: {
        setTarefas(context, payload) {
            context.commit('setTarefas', payload);
        },
        setCategoria(context, payload) {
            context.commit('setCategoria', payload);
        },
        setCodigo(context, payload) {
            context.commit('setCodigo', payload);
        },
        setValidade(context, payload) {
            context.commit('setValidade', payload);
        },
    },
    getters: {
        getTarefas(state) {
            return state.tarefas;
        },
        getCategorias(state) {
            let tarefas = state.tarefas;

            return tarefas.reduce(function (key, element) {
                key[element.categoria] = key[element.categoria] || [];
                key[element.categoria].push(element);
                return key;
            }, Object.create(null));
        },
        getTarefasCategoria(state) {
            let prod = state.tarefas;

            let filtrados = prod.filter((element) => {
                return element.categoria == state.categoria;
            });

            return filtrados.reduce(function (key, element) {
                key[element.categoria_3] = key[element.categoria_3] || [];
                key[element.categoria_3].push(element);
                return key;
            }, Object.create(null));
        },
        getTotalTarefas(state) {
            return state.tarefas.length;
        },
        getCategoria(state) {
            return state.categoria;
        },
        getTarefa(state) {
            let prod = state.tarefas;

            let filtrados = prod.filter((element) => {
                return element.codigo_de_barras == state.codigo_de_barras && element.data_validade == state.validade;
            });

            return filtrados[0];
        },
    },
};

export default tarefaStore;
